import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, ShoppingCart, History, Camera, User } from 'lucide-react';

const navItems = [
  { path: '/agent/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { path: '/agent/sell', label: 'Sell Tickets', icon: ShoppingCart },
  { path: '/agent/sales', label: 'My Sales', icon: History },
  { path: '/agent/validate', label: 'Validate Ticket', icon: Camera },
  { path: '/agent/profile', label: 'My Agent Profile', icon: User },
];

export const AgentLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white dark:from-gray-950 dark:to-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex gap-8">
          <aside className="w-56 flex-shrink-0">
            <nav className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-100 dark:border-gray-800 shadow-sm p-3 space-y-1 sticky top-8">
              <p className="text-[10px] uppercase tracking-widest text-gray-400 dark:text-gray-500 font-semibold px-3 pt-1 pb-2">Agent Portal</p>
              {navItems.map((item) => {
                const Icon = item.icon;
                const isActive = location.pathname === item.path;
                return (
                  <Link key={item.path} to={item.path}
                    className={`flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all ${
                      isActive
                        ? 'bg-indigo-600 text-white shadow-md shadow-indigo-200 dark:shadow-indigo-900'
                        : 'text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800 hover:text-gray-900 dark:hover:text-gray-200'
                    }`}>
                    <Icon className="h-4 w-4" />{item.label}
                  </Link>
                );
              })}
            </nav>
          </aside>
          <main className="flex-1 min-w-0">{children}</main>
        </div>
      </div>
    </div>
  );
};
